import { render } from "./FinanceCard.vue?vue&type=template&id=a1b8b1ea&scoped=true"
import script from "./FinanceCard.vue?vue&type=script&lang=js"
export * from "./FinanceCard.vue?vue&type=script&lang=js"

import "./FinanceCard.vue?vue&type=style&index=0&id=a1b8b1ea&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1b8b1ea"]])

export default __exports__